<div class="modal fade hierarchy-modal" id="reportModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title fs-6">
          <span class="modal-title-icon"><i class="fa fa-file-text"></i></span>
          گزارش
        </h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="بستن"></button>
      </div>
      <div class="modal-body">
        <div class="row g-0 hierarchy-layout">
          <div class="col-md-5 parents-panel">
            <div class="section-title">
              <h6><i class="fa fa-folder text-primary"></i> دسته‌بندی‌ها</h6>
            </div>
            <div class="parent-list">
              <button type="button" class="parent-card" [class.active]="bReportOperations" (click)="selectOperation('bReportOperations')">
                <span class="parent-icon"><i class="fa fa-cogs"></i></span>
                <span class="parent-content"><span class="parent-name">عملیاتی</span></span>
                <i class="fa fa-chevron-left parent-chevron"></i>
              </button>
              <button type="button" class="parent-card" [class.active]="bFinancialOperations" (click)="selectOperation('bFinancialOperations')">
                <span class="parent-icon"><i class="fa fa-money"></i></span>
                <span class="parent-content"><span class="parent-name">مالی و محدوده‌ای</span></span>
                <i class="fa fa-chevron-left parent-chevron"></i>
              </button>
              <button type="button" class="parent-card" [class.active]="bTankerOperations" *ngIf="car?.bTanker == 1" (click)="selectOperation('bTankerOperations')">
                <span class="parent-icon"><i class="fa fa-truck"></i></span>
                <span class="parent-content"><span class="parent-name">تانکر</span></span>
                <i class="fa fa-chevron-left parent-chevron"></i>
              </button>
              <button type="button" class="parent-card" [class.active]="bSalary" *ngIf="car?.tiMobileGroup == 232" (click)="selectOperation('bSalary')">
                <span class="parent-icon"><i class="fa fa-users"></i></span>
                <span class="parent-content"><span class="parent-name">ایاب و ذهاب</span></span>
                <i class="fa fa-chevron-left parent-chevron"></i>
              </button>
              <button type="button" class="parent-card" [class.active]="bFuelSensor" *ngIf="car?.bFuelSensor" (click)="selectOperation('bFuelSensor')">
                <span class="parent-icon"><i class="fa fa-tint"></i></span>
                <span class="parent-content"><span class="parent-name">پایش باک سوخت</span></span>
                <i class="fa fa-chevron-left parent-chevron"></i>
              </button>
              <button type="button" class="parent-card" [class.active]="bWeightSensor" *ngIf="car?.bWeightSensor == 1" (click)="selectOperation('bWeightSensor')">
                <span class="parent-icon"><i class="fa fa-balance-scale"></i></span>
                <span class="parent-content"><span class="parent-name">وزن</span></span>
                <i class="fa fa-chevron-left parent-chevron"></i>
              </button>
              <button type="button" class="parent-card" [class.active]="bTemperatureSensor" *ngIf="car?.bTemperatureSensor == 1" (click)="selectOperation('bTemperatureSensor')">
                <span class="parent-icon"><i class="fa fa-thermometer-half"></i></span>
                <span class="parent-content"><span class="parent-name">دما</span></span>
                <i class="fa fa-chevron-left parent-chevron"></i>
              </button>
              <button type="button" class="parent-card" [class.active]="bFlowmeter" *ngIf="car?.bFlowmeter == 1" (click)="selectOperation('bFlowmeter')">
                <span class="parent-icon"><i class="fa fa-tachometer"></i></span>
                <span class="parent-content"><span class="parent-name">پایش فلومتر</span></span>
                <i class="fa fa-chevron-left parent-chevron"></i>
              </button>
            </div>
          </div>
          <div class="col-md-7 children-panel">
            <div *ngIf="bReportOperations" class="selected-parent-heading">
              <span class="selected-parent-badge"><i class="fa fa-cogs"></i></span>
              <div><h5>عملیاتی</h5><p>یکی از گزارش‌ها را انتخاب کنید.</p></div>
            </div>
            <div *ngIf="bFinancialOperations" class="selected-parent-heading">
              <span class="selected-parent-badge"><i class="fa fa-money"></i></span>
              <div><h5>مالی و محدوده‌ای</h5><p>یکی از گزارش‌ها را انتخاب کنید.</p></div>
            </div>
            <div *ngIf="bTankerOperations" class="selected-parent-heading">
              <span class="selected-parent-badge"><i class="fa fa-truck"></i></span>
              <div><h5>تانکر</h5><p>یکی از گزارش‌ها را انتخاب کنید.</p></div>
            </div>
            <div *ngIf="bSalary" class="selected-parent-heading">
              <span class="selected-parent-badge"><i class="fa fa-users"></i></span>
              <div><h5>ایاب و ذهاب</h5><p>یکی از گزارش‌ها را انتخاب کنید.</p></div>
            </div>
            <div *ngIf="bFuelSensor" class="selected-parent-heading">
              <span class="selected-parent-badge"><i class="fa fa-tint"></i></span>
              <div><h5>پایش باک سوخت</h5><p>یکی از گزارش‌ها را انتخاب کنید.</p></div>
            </div>
            <div *ngIf="bWeightSensor" class="selected-parent-heading">
              <span class="selected-parent-badge"><i class="fa fa-balance-scale"></i></span>
              <div><h5>وزن</h5><p>یکی از گزارش‌ها را انتخاب کنید.</p></div>
            </div>
            <div *ngIf="bTemperatureSensor" class="selected-parent-heading">
              <span class="selected-parent-badge"><i class="fa fa-thermometer-half"></i></span>
              <div><h5>دما</h5><p>یکی از گزارش‌ها را انتخاب کنید.</p></div>
            </div>
            <div *ngIf="bFlowmeter" class="selected-parent-heading">
              <span class="selected-parent-badge"><i class="fa fa-tachometer"></i></span>
              <div><h5>پایش فلومتر</h5><p>یکی از گزارش‌ها را انتخاب کنید.</p></div>
            </div>
            <div class="children-scroll is-scrollable">
              <div class="children-grid">
                <ng-container *ngIf="bReportOperations">
                  <button type="button" class="child-card" *ngIf="acssess?.bReportStop" data-bs-toggle="modal" data-bs-target="#exampleModal3">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-red"><i class="fa fa-pause"></i></span>
                    <span class="d-block child-title">توقف</span>
                    <span class="child-description">گزارش توقفات </span>
                  </button>
                  <button type="button" class="child-card" *ngIf="acssess?.bReportDaily" data-bs-toggle="modal" data-bs-target="#exampleModal4">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-blue"><i class="fa fa-road"></i></span>
                    <span class="d-block child-title">کارکرد</span>
                    <span class="child-description">گزارش کارکرد روزانه</span>
                  </button>
                  <button type="button" class="child-card d-none" *ngIf="acssess?.bReportExitDomain">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-orange"><i class="fa fa-sign-out"></i></span>
                    <span class="d-block child-title">تخلف خروج از محدوده</span>
                    <span class="child-description">تخلف خروج از محدوده</span>
                  </button>
                  <button type="button" class="child-card d-none" *ngIf="acssess?.bReportEnterDomain">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-orange"><i class="fa fa-sign-in"></i></span>
                    <span class="d-block child-title">تخلف ورود به محدوده</span>
                    <span class="child-description">تخلف ورود به محدوده</span>
                  </button>
                  <button type="button" class="child-card" *ngIf="acssess?.bReportRefueling" data-bs-toggle="modal" data-bs-target="#exampleModal5" (click)="changeApi('13')">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-cyan"><i class="fa fa-tint"></i></span>
                    <span class="d-block child-title">سوختگیری</span>
                    <span class="child-description">سوابق سوختگیری </span>
                  </button>
                  <button type="button" class="child-card" *ngIf="acssess?.bReportViolation" data-bs-toggle="modal" data-bs-target="#exampleModal5" (click)="changeApi('3')">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-orange"><i class="fa fa-ban"></i></span>
                    <span class="d-block child-title">تخلف ها رانندگان</span>
                    <span class="child-description">تخلفات ثبت‌شده رانندگان</span>
                  </button>
                  <button type="button" class="child-card" *ngIf="acssess?.bReportRepair" data-bs-toggle="modal" data-bs-target="#exampleModal5" (click)="changeApi('4')">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-indigo"><i class="fa fa-wrench"></i></span>
                    <span class="d-block child-title">تعمیرات </span>
                    <span class="child-description">سوابق تعمیرات </span>
                  </button>
                  <button type="button" class="child-card" *ngIf="acssess?.bReportGPSJournal" data-bs-toggle="modal" data-bs-target="#exampleModal5" (click)="changeApi('7')">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-purple"><i class="fa fa-bell"></i></span>
                    <span class="d-block child-title">وقایع ردیاب</span>
                    <span class="child-description">وقایع ثبت‌شده ردیاب</span>
                  </button>
                  <button type="button" class="child-card" *ngIf="acssess?.bReportGPSIO" data-bs-toggle="modal" data-bs-target="#exampleModal5" (click)="changeApi('8')">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-teal"><i class="fa fa-keyboard-o"></i></span>
                    <span class="d-block child-title">ورودی ها ردیاب</span>
                    <span class="child-description">ورودی‌های ردیاب</span>
                  </button>
                  <button type="button" class="child-card" *ngIf="acssess?.bReportVelocity" data-bs-toggle="modal" data-bs-target="#exampleModal3" (click)="changeApi('15')">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-green"><i class="fa fa-tachometer"></i></span>
                    <span class="d-block child-title">نمودار سرعت </span>
                    <span class="child-description">نمودار سرعت </span>
                  </button>
                  <button type="button" class="child-card" *ngIf="acssess?.bReportVelocity" data-bs-toggle="modal" data-bs-target="#exampleModal3" (click)="changeApi('15-3')">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-pink"><i class="fa fa-line-chart"></i></span>
                    <span class="d-block child-title">نمودار شتاب</span>
                    <span class="child-description">نمودار شتاب </span>
                  </button>
                  <button type="button" class="child-card" *ngIf="acssess?.bServiceDelivery" data-bs-toggle="modal" data-bs-target="#exampleModal5" (click)="changeApi('19')">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-amber"><i class="fa fa-truck"></i></span>
                    <span class="d-block child-title">گزارش خدمات رسانی</span>
                    <span class="child-description">گزارش خدمات‌رسانی </span>
                  </button>
                  <button type="button" class="child-card" *ngIf="acssess?.bComprehensiveReport">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-blue"><i class="fa fa-file-text-o"></i></span>
                    <span class="d-block child-title">گزارش جامع</span>
                    <span class="child-description">گزارش جامع </span>
                  </button>
                </ng-container>

                <ng-container *ngIf="bFinancialOperations">
                  <button type="button" class="child-card" *ngIf="acssess?.bSalari" (click)="salary()">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-green"><i class="fa fa-money"></i></span>
                    <span class="d-block child-title">حقوق - ورود خروج</span>
                    <span class="child-description">حقوق بر اساس ورود و خروج</span>
                  </button>
                  <button type="button" class="child-card" *ngIf="acssess?.bSalariBaseZone" (click)="salaryBaseZone()">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-teal"><i class="fa fa-map"></i></span>
                    <span class="d-block child-title">حقوق - محدوده فعالیت</span>
                    <span class="child-description">حقوق بر اساس محدوده فعالیت</span>
                  </button>
                  <button type="button" class="child-card" *ngIf="acssess?.bReportInOutDomain" data-bs-toggle="modal" data-bs-target="#exampleModal5" (click)="changeApi('9')">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-purple"><i class="fa fa-exchange"></i></span>
                    <span class="d-block child-title">ورود و خروج به محدوده</span>
                    <span class="child-description">تردد در محدوده‌ها</span>
                  </button>
                  <button type="button" class="child-card" *ngIf="acssess?.bReportIncome" data-bs-toggle="modal" data-bs-target="#exampleModal5" (click)="changeApi('5')">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-blue"><i class="fa fa-bar-chart"></i></span>
                    <span class="d-block child-title">درآمد ها</span>
                    <span class="child-description">درآمدهای ثبت‌شده</span>
                  </button>
                  <button type="button" class="child-card" *ngIf="acssess?.bReportIncomeEexpense" data-bs-toggle="modal" data-bs-target="#exampleModal5" (click)="changeApi('6')">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-pink"><i class="fa fa-pie-chart"></i></span>
                    <span class="d-block child-title">درآمد ها / هزینه ها</span>
                    <span class="child-description">تراز درآمد و هزینه</span>
                  </button>
                  <button type="button" class="child-card" *ngIf="acssess?.bFunctionSD" (click)="sourceDestEarning()">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-indigo"><i class="fa fa-map-signs"></i></span>
                    <span class="d-block child-title">کارکرد مابین مبدا و مقصد</span>
                    <span class="child-description">کارکرد بین مبدا و مقصد</span>
                  </button>
                  <button type="button" class="child-card" *ngIf="acssess?.bTransportation_DailyReport" (click)="sourceDestEarning(20)">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-amber"><i class="fa fa-users"></i></span>
                    <span class="d-block child-title">عملکرد ایاب و ذهاب</span>
                    <span class="child-description">عملکرد سرویس ایاب و ذهاب</span>
                  </button>
                  <button type="button" class="child-card" *ngIf="acssess?.bMobilesInspection" (click)="inspectionReport()">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-cyan"><i class="fa fa-map-o"></i></span>
                    <span class="d-block child-title">حرکت مابین محدوده ها</span>
                    <span class="child-description">حرکت بین محدوده‌ها</span>
                  </button>
                  <button type="button" class="child-card" *ngIf="acssess?.bMobilesInspection" (click)="inspectionReport('18-0')">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-orange"><i class="fa fa-map"></i></span>
                    <span class="d-block child-title">عملکرد مابین محدودها</span>
                    <span class="child-description">عملکرد بین محدوده‌ها</span>
                  </button>
                </ng-container>

                <ng-container *ngIf="bTankerOperations">
                  <button type="button" class="child-card d-none" *ngIf="acssess?.bTanker_Reports" data-bs-toggle="modal" data-bs-target="#exampleModal3" (click)="changeApi('15-1')">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-teal"><i class="fa fa-clock-o"></i></span>
                    <span class="d-block child-title"><small> تخلیه براساس زمان </small></span>
                    <span class="child-description">تخلیه بر اساس زمان</span>
                  </button>
                  <button type="button" class="child-card d-none" *ngIf="acssess?.bTanker_Reports" data-bs-toggle="modal" data-bs-target="#exampleModal3" (click)="changeApi('15-2')">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-green"><i class="fa fa-tachometer"></i></span>
                    <span class="d-block child-title"><small> تخلیه براساس سرعت </small></span>
                    <span class="child-description">تخلیه بر اساس سرعت</span>
                  </button>
                  <button type="button" class="child-card" *ngIf="car?.tiMobileType == 99" data-bs-toggle="modal" data-bs-target="#exampleModal" (click)="onTankerRouteClick()">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-indigo"><i class="fa fa-truck"></i></span>
                    <span class="d-block child-title"><small> بررسی عملکرد تانکر </small></span>
                    <span class="child-description">بررسی عملکرد تانکر</span>
                  </button>
                  <button type="button" class="child-card" *ngIf="acssess?.bTanker_Reports" data-bs-toggle="modal" data-bs-target="#exampleModal3" (click)="onTankerMoodClick('1-1')">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-green"><i class="fa fa-plus-circle"></i></span>
                    <span class="d-block child-title"><small> جزییات تغذیه تانکر </small></span>
                    <span class="child-description">جزئیات تغذیه تانکر</span>
                  </button>
                  <button type="button" class="child-card" *ngIf="acssess?.bTanker_Reports" data-bs-toggle="modal" data-bs-target="#exampleModal3" (click)="onTankerMoodClick('1-2')">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-red"><i class="fa fa-minus-circle"></i></span>
                    <span class="d-block child-title"><small> جزییات تخلیه از تانکر </small></span>
                    <span class="child-description">جزئیات تخلیه از تانکر</span>
                  </button>
                </ng-container>

                <ng-container *ngIf="bSalary">
                  <button type="button" class="child-card" (click)="showAyab_Zahab(1)">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-blue"><i class="fa fa-users"></i></span>
                    <span class="d-block child-title"><small> مسافرین فعلی </small></span>
                    <span class="child-description">مسافران فعلی سرویس</span>
                  </button>
                  <button type="button" class="child-card" (click)="showAyab_Zahab(2)">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-purple"><i class="fa fa-list"></i></span>
                    <span class="d-block child-title"><small> سرجمع مسافرین </small></span>
                    <span class="child-description">سرجمع مسافران</span>
                  </button>
                </ng-container>

                <ng-container *ngIf="bFuelSensor">
                  <button type="button" class="child-card" data-bs-toggle="modal" data-bs-target="#exampleModal4_1">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-blue"><i class="fa fa-area-chart"></i></span>
                    <span class="d-block child-title"><small> نمودار مصرف براساس زمان </small></span>
                    <span class="child-description">نمودار مصرف در بازه زمانی</span>
                  </button>
                  <button type="button" class="child-card" data-bs-toggle="modal" data-bs-target="#exampleModal4_2">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-cyan"><i class="fa fa-tint"></i></span>
                    <span class="d-block child-title"><small> سوخت گیری </small></span>
                    <span class="child-description">سوابق سوختگیری</span>
                  </button>
                  <button type="button" class="child-card" data-bs-toggle="modal" data-bs-target="#exampleModal4_3">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-red"><i class="fa fa-exclamation-triangle"></i></span>
                    <span class="d-block child-title"><small> تخلیه های مشکوک </small></span>
                    <span class="child-description">تخلیه‌های مشکوک سوخت</span>
                  </button>
                  <button type="button" class="child-card">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-pink"><i class="fa fa-pie-chart"></i></span>
                    <span class="d-block child-title"><small> تحلیل مصرف </small></span>
                    <span class="child-description">تحلیل مصرف سوخت</span>
                  </button>
                  <button type="button" class="child-card" data-bs-toggle="modal" data-bs-target="#exampleModal4_4">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-indigo"><i class="fa fa-calculator"></i></span>
                    <span class="d-block child-title"><small> سوخت خالص مصرفی </small></span>
                    <span class="child-description">محاسبه سوخت خالص</span>
                  </button>
                  <button type="button" class="child-card" data-bs-toggle="modal" data-bs-target="#exampleModal4_5">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-green"><i class="fa fa-line-chart"></i></span>
                    <span class="d-block child-title"><small> روند مصرف سوخت </small></span>
                    <span class="child-description">روند مصرف در طول زمان</span>
                  </button>
                  <button type="button" class="child-card" data-bs-toggle="modal" data-bs-target="#exampleModal4_6">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-amber"><i class="fa fa-clock-o"></i></span>
                    <span class="d-block child-title"><small> سوخت مصرفی لحظه‌ای </small></span>
                    <span class="child-description">مصرف لحظه‌ای سوخت</span>
                  </button>
                </ng-container>

                <ng-container *ngIf="bWeightSensor">
                  <button type="button" class="child-card">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-green"><i class="fa fa-line-chart"></i></span>
                    <span class="d-block child-title"><small> روند تغییر وزن </small></span>
                    <span class="child-description">نمودار تغییرات وزن</span>
                  </button>
                  <button type="button" class="child-card">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-blue"><i class="fa fa-upload"></i></span>
                    <span class="d-block child-title"><small> گزارش های بارگیری </small></span>
                    <span class="child-description">سوابق بارگیری</span>
                  </button>
                  <button type="button" class="child-card">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-orange"><i class="fa fa-download"></i></span>
                    <span class="d-block child-title"><small> گزارش های تخلیه </small></span>
                    <span class="child-description">سوابق تخلیه</span>
                  </button>
                  <button type="button" class="child-card">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-purple"><i class="fa fa-exchange"></i></span>
                    <span class="d-block child-title"><small> گزارش بارگیری - تخلیه </small></span>
                    <span class="child-description">ترکیب بارگیری و تخلیه</span>
                  </button>
                </ng-container>

                <ng-container *ngIf="bTemperatureSensor">
                  <button type="button" class="child-card">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-red"><i class="fa fa-thermometer-half"></i></span>
                    <span class="d-block child-title"><small> روند تغییر دما </small></span>
                    <span class="child-description">نمودار تغییرات دما</span>
                  </button>
                  <button type="button" class="child-card">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-amber"><i class="fa fa-bolt"></i></span>
                    <span class="d-block child-title"><small> تغییرات ناگهانی دما </small></span>
                    <span class="child-description">شوک‌های دمایی</span>
                  </button>
                </ng-container>

                <ng-container *ngIf="bFlowmeter">
                  <button type="button" class="child-card" data-bs-toggle="modal" data-bs-target="#exampleModal4_7">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-cyan"><i class="fa fa-tint"></i></span>
                    <span class="d-block child-title"><small> نمودار روند جریان </small></span>
                    <span class="child-description">نمودار جریان فلومتر</span>
                  </button>
                  <button type="button" class="child-card">
                    <span class="child-check"><i class="fa fa-check"></i></span>
                    <span class="child-icon ic-teal"><i class="fa fa-tachometer"></i></span>
                    <span class="d-block child-title"><small> سرجمع جریان </small></span>
                    <span class="child-description">سرجمع جریان عبوری</span>
                  </button>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer hierarchy-footer">
        <button class="btn btn-outline-secondary" data-bs-dismiss="modal">بستن</button>
      </div>
    </div>
  </div>
</div>